import { ExistingProvider, Injectable } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class StandardErrorsInterceptor implements HttpInterceptor {
	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError(
				(response: HttpErrorResponse) => {
					switch(response.status) {
						case 401: // UNAUTHORIZED
							// L'utilisateur n'est pas authentifie et doit se logger via Okta
							let loginUrl = (window as any).resourcesPath + "saml2/authenticate/okta";

							// Recuperer la page en cours d'affichage (anchor tag)
							let currentUrl = document.URL;
							let parts = currentUrl.split("#/");
							if (parts.length > 1 && parts[1] !== "") {
								// La transmettre en parametre pour que le serveur puis rediriger dessus
								// apres authentification
								loginUrl += "?returnTo=" + parts[1];
							}
							
							// Naviguer vers la page de login
							// (ceci interrompera la plupart des scripts)
							window.location.href = loginUrl;
							break;
						case 500: // INTERNAL SERVEUR ERROR
							// Le serveur a rencontre une exception, on va juste afficher un message d'alerte a l'utilisateur
							console.log("Le serveur a rencontré une erreur imprévue");
							break;
						default:
					}
					
					// Dans tous les cas ou on ne redefinit par le resultat de la requete, il faut
					// l'interrompre par une nouvelle erreur
					return throwError(response);
				}
			),
		);
	}
}

export const StandardErrorsInterceptorProvider: ExistingProvider[] = [{
	provide: HTTP_INTERCEPTORS,
	useExisting: StandardErrorsInterceptor,
	multi: true
}];